const getPipelinesUrls = require('../common/getPipelinesUrls');
const { urlWithSearchParams } = require('./urlUtilities');

const pipelinesUrls = getPipelinesUrls();

/**
 * Fetch the contact key associated to an email address
 * @param {string} emailAddress The email of the guest user
 * @returns {string|null} Contact key
 */
async function getContactKeyForEmailAddress(emailAddress) {
    var response = await fetch(
        urlWithSearchParams(pipelinesUrls.sfmcGetContactKey, {
            email: emailAddress
        })
    );
    if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
    }
    var responseData = await response.json();
    if (responseData.ok) {
        return responseData.contactKey;
    }
    return null;
}

/**
 * Create a new contact for a guest user
 *
 * @param {HTMLElement} form The form element with the email to create the contact
 * @returns {Object} The result from the server
 */
async function createContact(form) {
    const formData = new FormData(form);
    const body = new URLSearchParams(formData);
    var response = await fetch(
        pipelinesUrls.sfmcCreateContact,
        {
            method: 'POST',
            body
        }
    );
    if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
    }
    return response.json();
}

module.exports = {
    createContact: createContact,
    getContactKeyForEmailAddress: getContactKeyForEmailAddress
};
